import styled from "styled-components";
import { useViewState } from "../Context/ViewStateContext";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A button as link that provides common styling for custom component types
 * that open a feature.
 */
const FeatureLink = _ref => {
  let {
    title,
    onClick,
    children
  } = _ref;
  const viewState = useViewState();
  return /*#__PURE__*/_jsx(ButtonAsLink, {
    title: title,
    onClick: e => {
      e.stopPropagation();
      onClick(viewState);
    },
    children: children
  });
};
const ButtonAsLink = styled.button.withConfig({
  displayName: "FeatureLink__ButtonAsLink",
  componentId: "sc-1phsv42-0"
})(["background:none;border:none;text-decoration:underline dashed;color:inherit;"]);
export default FeatureLink;